<template>
  <div class="spotcheck">
    <my-head :title="title"/>
    <!-- <mu-text-field v-model="form.vin" @blur="" placeholder="VIN" ref="vin" class='input auto-width' @keyup.enter.native="getData()"><i class="iconfont icon-saomiao" @click="scan('vin')"></i></mu-text-field> -->
    <mu-row class="auto-width" gutter>
      <mu-col span="4"><div class="grid-cell text-right">VIN：</div></mu-col>
      <mu-col span="8"><div class="grid-cell">{{form.vin}}</div></mu-col>
      <mu-col span="4"><div class="grid-cell text-right">相关单号：</div></mu-col>
      <mu-col span="8">
        <div class="grid-cell"><mu-text-field v-model="form.ASNcode" @blur="" placeholder="" class='auto-width-s'></mu-text-field></div>
      </mu-col>
      <mu-col span="4"><div class="grid-cell text-right">公里数：</div></mu-col>
      <mu-col span="8"><div class="grid-cell"><mu-text-field v-model="form.mile" @blur="" placeholder="" class='auto-width-s'></mu-text-field></div></mu-col>
      <mu-col span="4"><div class="grid-cell text-right">高压电量：</div></mu-col>
      <mu-col span="8">
        <div class="grid-cell"><mu-text-field v-model="form.highEectricity" @blur="" placeholder="" class='auto-width-s'></mu-text-field></div>
      </mu-col>
      <mu-col span="4"><div class="grid-cell text-right">低压电量：</div></mu-col>
      <mu-col span="8"><div class="grid-cell"><mu-text-field v-model="form.lowEectricity" @blur="" placeholder="" class='auto-width-s'></mu-text-field></div></mu-col>

      <mu-col span="5"><div class="grid-cell text-right">遥控钥匙数目：</div></mu-col>
      <mu-col span="7"><div class="grid-cell"><mu-text-field v-model="form.remoteKeyNum" @blur="" placeholder="" class='auto-width-s'></mu-text-field></div></mu-col>
      <mu-col span="5"><div class="grid-cell text-right">机械钥匙数目：</div></mu-col>
      <mu-col span="7"><div class="grid-cell"><mu-text-field v-model="form.mechanicalKeyNum" @blur="" placeholder="" class='auto-width-s'></mu-text-field></div></mu-col>

    </mu-row>

    <mu-row class="auto-width" gutter>
      <mu-col span="6">
        <div class="grid-cell">
          <mu-checkbox v-model="form.isHighEectricity" value="true" label="涉及高压电" @change="changeCheckBox"></mu-checkbox>
        </div>
      </mu-col>
      <mu-col span="6">
        <div class="grid-cell">
          <mu-checkbox v-model="form.isLowEectricity" value="true" label="涉及低压电" @change="changeCheckBox"></mu-checkbox>
        </div>
      </mu-col>
      <mu-col span="6">
        <div class="grid-cell">
          <mu-checkbox v-model="form.isAttachmentFinish" value="附件袋是否完整" label="附件袋是否完整" @change="changeCheckBox"></mu-checkbox>
        </div>
      </mu-col>
    </mu-row>

    <mu-text-field class="input auto-width" v-model="form.qcRemark" placeholder="质损情况描述" multi-line :rows="3" :rows-max="3"></mu-text-field>

    <!--图片全屏预览-->
    <mu-dialog width="360" transition="slide-bottom" fullscreen :open.sync="openFullscreen">
      <mu-appbar color="" title="">
      <mu-button slot="right" flat  @click="closeFullscreenDialog">关闭</mu-button>
      </mu-appbar>
      <div id='ylbox'>
        <mu-carousel :cycle="false">
          <mu-carousel-item>
            <img :src="bigImg">
          </mu-carousel-item>
        </mu-carousel>
      </div>
    </mu-dialog>

    <div class="photos">
      <div class="imgs" v-for="(item, index) in src" :key="index" @touchstart.stop="touchin(index)" @touchend.stop="cleartime()" @click.stop="openFullscreenDialog(index)">
        <img :src="item" >
      </div>
      <i class="iconfont icon-icon25201" @click="paizhao"></i>
    </div>

    <mu-dialog width="320" max-width="60%" :open.sync="openAlert">
      确认删除图片?
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialog('n')">取消</mu-button>
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialog('y')">删除</mu-button>
    </mu-dialog>

    <mu-data-table id="mytable" :loading="tableLoading" :columns="columns" :sort.sync="sort" @sort-change="handleSortChange" :data="list">
      <template slot-scope="scope">
        <td>{{scope.row.itemName}}</td>
        <td>{{scope.row.unit}}</td>
        <td>{{scope.row.quantity}}</td>
        <td><mu-text-field v-model="scope.row.qty"></mu-text-field></td>
      </template>
    </mu-data-table>

    <mu-dialog width="320" max-width="60%" :open.sync="openAlertDj">
      是否点检?
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialogGoRecord('n')">取消</mu-button>
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialogGoRecord('y')">确认</mu-button>
    </mu-dialog>

    <div class="spotcheck-btns auto-width">
      <mu-button color="info" :disabled="isSubmited" @click="openAlertDj = true">提交修改</mu-button>
    </div>
    <scanning v-if="isScanning" :mark="scanMark" v-on:childByValue="childByValue" v-on:closeing="closeing"/>

  </div>
</template>

<script>
import myHead from '@/components/header'
import api from '@/common/api'
import scanning from '@/components/scanning'
export default {
  name: 'pickcar',
  components: {
    myHead, scanning
  },
  data () {
    return {
      title: '点检',
      scanMark: '',
      type: '',
      tableLoading: false,
      isScanning: false,
      openFullscreen: false,
      deleteIndex: null, // 删除第几张
      openAlertDj: false,
      openAlert: false, // 删除图片层
      src: [], // 拍照的图片
      files: [], // 图片文件 base64
      bigImg: null,
      otherTaskTo: false,
      requestOnce: true,
      isSubmited: false,
      Loop: null,
      form: {
        vin: '',
        ASNid: '',
        id: '',
        mile: '',
        ASNcode: '',
        lowEectricity: '',
        highEectricity: '',
        remoteKeyNum: '',
        mechanicalKeyNum: '',
        isLowEectricity: false,
        isHighEectricity: false,
        isAttachmentFinish: false,
        qcRemark: ''
      },
      sort: {
        name: '',
        order: 'asc'
      },
      columns: [
        { title: '点检项', width: 125, name: 'itemName' },
        { title: '单位', name: 'unit', width: 70, align: 'left'},
        { title: '数量', name: 'quantity', width: 70, align: 'left'},
        { title: '点检数量', name: 'qty', width: 'auto', align: 'left'}
      ],
      list: []
    }
  },
  methods: {
    goRecord () {
      // 跳转点检记录
      this.$router.push({ path: '/spotchecksearch', query: {type: this.title}})
    },
    getData () {
      this.Toast.loading({message: '查询中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          vin: this.form.vin,
          code: this.type
        }
      })
      this.tableLoading = true
      /* 发送post请求 */
      if (this.requestOnce) {
        this.common.reqData(api.app('CheckRecordGetVin'), data, res => {
          this.requestOnce = true
          this.Toast.clear()
          this.tableLoading = false
          console.log('返回数据：', res.data)
          if (res.data.status == 100) {
            this.list = res.data.content.Details || []
            this.form.ASNid = res.data.content.ASNid
            this.form.id = res.data.content.id
            this.form.mile = res.data.content.mile
            this.form.lowEectricity = res.data.content.lowEectricity
            this.form.highEectricity = res.data.content.highEectricity

            this.form.remoteKeyNum = res.data.content.remoteKeyNum
            this.form.mechanicalKeyNum = res.data.content.mechanicalKeyNum

            this.form.isHighEectricity = res.data.content.isHighEectricity
            this.form.isAttachmentFinish = res.data.content.isAttachmentFinish
            this.form.qcRemark = res.data.content.qcRemark
            this.form.ASNcode = res.data.content.ASNcode
            this.form.isLowEectricity = res.data.content.isLowEectricity
            this.isSubmited = false
          } else {
            this.Toast({
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.requestOnce = true
          this.tableLoading = false
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },
    touchin (index) {
      var _this = this
      clearInterval(this.Loop) // 再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(function () {
        _this.deleteImgDialog(index)
      }, 500)
    },
    cleartime (id, course_id) {
      // 这个方法主要是用来将每次手指移出之后将计时器清零
      clearInterval(this.Loop)
    },
    openFullscreenDialog (index) {
      this.bigImg = this.src[index]
      this.openFullscreen = true
    },
    closeFullscreenDialog () {
      this.openFullscreen = false
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name])
    },
    changeCheckBox (v) {
      console.log(this.form.checkbox)
    },
    deleteImgDialog (index) {
      // 删除图片 打开
      this.deleteIndex = index
      this.openAlert = true
    },
    closeAlertDialogGoRecord (state) {
      if (state === 'y') {
        this.submits()
      }
      this.openAlertDj = false
    },
    closeAlertDialog (state) {
      // 删除图片 关闭
      if (state === 'y') {
        this.src.splice(this.deleteIndex, 1)
        this.files.splice(this.deleteIndex, 1)
      }
      this.openAlert = false
    },

    submits () {
      this.Toast.loading({message: '提交中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          form: this.form,
          details: this.list,
          code: this.type,
          files: this.files
        }
      })
      /* 发送post请求 */
      if (this.requestOnce) {
        this.common.reqData(api.app('CheckRecordSaveCheckRecord'), data, res => {
          this.requestOnce = true
          this.Toast.clear()
          console.log('返回数据：', res.data)
          if (res.data.status == 100) {
            this.Toast({
              duration: 2000,
              mask: true,
              message: '提交成功'
            })
            this.isSubmited = true
          } else {
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.requestOnce = true
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },

    paizhao () {
      let _this = this
      if (window.plus) {
        var cmr = plus.camera.getCamera()
        var res = cmr.supportedImageResolutions[0]
        var fmt = cmr.supportedImageFormats[0]
        console.log('Resolution: ' + res + ', Format: ' + fmt)
        cmr.captureImage(function (path) {
          plus.io.resolveLocalFileSystemURL(path, function (entry) {
            // 转化本地绝对路径
            var url = plus.io.convertLocalFileSystemURL(path)
            _this.src.push('file://' + url)
            // 获取图片对象
            entry.file(function (file) {
              var fileReader = new plus.io.FileReader()
              fileReader.onloadend = function (evt) {
                console.log(evt.target.result)
                _this.files.push(evt.target.result)
              }
              fileReader.readAsDataURL(file)
            })
          })
        },
        function (error) {
          console.log('拍照已经取消: ' + error.message)
        },
        {resolution: res, format: fmt}
        )
      }
    },
    closeing (val) {
      val ? this.isScanning = false : null
    },
    childByValue (val) {
      if (val) {
        if (val.split('&')[1] == 'vin') {
          this.form.vin = val.split('&')[0]
          this.getData()
        }
      }
    },
    scan (txt) {
      this.scanMark = txt
      this.isScanning = true
    },
    closeFullscreenDialog () {
      this.openFullscreen = false
      // this.closeScan();
    }
  },
  mounted () {
    this.title = this.$route.query.type || '点检'
    this.form = this.$route.query.info || {}
    console.log('this.form', this.form)
    this.list = this.form.details || []
    console.log('检查url： ', api.localhost)
    this.form.imgList.forEach(element => {
      let img = api.localhost + element.allImgUrl
      this.src.push(img)
      this.files.push(img)
    })
    console.log(this.form.imgList)
    if (this.title == '到港点检') {
      this.type = 'DGDJ'
    } else if (this.title == '出库点检') {
      this.type = 'CKDJ'
    } else if (this.title == '入库点检') {
      this.type = 'RKDJ'
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auto-width{
  width: 95%;
  margin: 10px auto;align-items: baseline!important;
}
.input{
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
#mytable .mu-input{
  width: 100%;
  margin: 0;
}
.spotcheck-btns{
  display: flex;
  width: 85%;
  margin-top: 20px;
  justify-content: flex-end;
}
.spotcheck-btns button{
  margin: 0 0;
}
.photos{
    border: 1px solid #ccc;
    width: 90%;
    margin: 20px auto 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
i.iconfont.icon-icon25201{
    display: block;
    font-size: 50px;
    margin: 10px;
}
.grid-cell.text-right{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/spotcheck/spotchecklist.vue